module.exports = __webpack_public_path__ + "img/hl-img.b3491bd5.png";